import { toast } from "react-toastify"
export const catchError = (ex, onError) => dispatch => {
    if (ex.response) {
        ex.response.json()
        .then(error => {
            toast(error, {
                type: "error"
            })
            return error
        })
        .then(error => dispatch(onError(error)));
    } else {
        if(ex.name != "AbortError") {
            toast(ex.toString(), { type: "error" })
        }
        dispatch(onError(ex));
    }
}